export default __webpack_public_path__ + "static/male6-03fa792092204737759ac07bf60bbc7e.png";